<ng-container *transloco="let tr; prefix: 'notifications'; scope: 'notifications'">
<nz-affix [nzOffsetTop]="0">
  <nz-page-header [nzGhost]="false">
    <nz-page-header-title>{{tr('title')}}</nz-page-header-title>
  </nz-page-header>
</nz-affix>
<!--<nz-skeleton *ngIf="isLoading" [nzActive]="true"></nz-skeleton>-->

<nz-table [nzLoading]="isTableLoading" #notificationsTable
          [nzTotal]="total"
          [nzPageSize]="limit"
          [nzPageIndex]="page"
          [nzData]="list"
          (nzQueryParams)="onQueryParamsChange($event)"
          [nzFrontPagination]="false">
  <thead>
  <tr>
    <th>{{tr('column.createDate')}}</th>
    <th>{{tr('column.topic')}}</th>
    <th>{{tr('column.text')}}</th>
    <th>{{tr('column.creator')}}</th>
    <th>{{tr('column.readDate')}}</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let data of notificationsTable.data">
    <td>{{data.createDate | date: 'dd.MM.yyyy HH:mm'}}</td>
    <td>{{data.topic}}</td>
    <td>{{data.text}}</td>
    <td>{{data.creator}}</td>
    <td>{{data.readDate | date: 'dd.MM.yyyy HH:mm'}}</td>
  </tr>
  </tbody>
</nz-table>
</ng-container>
